<template>
  <div class="meter-water-manage-container">
    <el-row :gutter="20">
      <el-col :span="4" class="tree-container">
        <room-tree-div ref="roomTree" @selectRoom="handleSelectRoom" />
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t("meterWater.queryConditions") }}</span>
          </div>
          <el-form
              :inline="true"
              :model="conditions"
              class="demo-form-inline text-left"
          >
            <el-form-item>
              <el-select
                  v-model="conditions.meterType"
                  :placeholder="$t('meterWater.selectMeterType')"
                  clearable
                  style="width: 100%"
                  @change="handleQuery"
              >
                <el-option
                    v-for="item in meterTypes"
                    :key="item.typeId"
                    :label="item.typeName"
                    :value="item.typeId"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                  v-model="conditions.waterId"
                  :placeholder="$t('meterWater.inputMeterId')"
                  clearable
                  @input="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                  v-model="conditions.paymentStatus"
                  :placeholder="$t('meterWater.paymentStatus')"
                  clearable
                  @input="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                  v-model="conditions.paymentType"
                  :placeholder="$t('meterWater.paymentType')"
                  clearable
                  @input="handleQuery"
              />
            </el-form-item>

            <!-- 上期读表时间区间 -->
            <el-form-item label="上期读表时间">
              <el-date-picker
                  v-model="preReadingTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="changePreReadingTime"
                  clearable
              ></el-date-picker>
            </el-form-item>

            <!-- 本期读表时间区间 -->
            <el-form-item label="本期读表时间">
              <el-date-picker
                  v-model="curReadingTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="changeCurReadingTime"
                  clearable
              ></el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button
                  type="success"
                  @click="exportExcel"
                  icon="el-icon-download"
              >
                导出Excel
              </el-button>
              <el-button type="primary" @click="handleQuery">{{
                  $t("common.query")
                }}</el-button>
              <el-button @click="handleReset">{{
                  $t("common.reset")
                }}</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="box-card margin-top">
          <div slot="header" class="flex justify-between">
            <span>{{ $t("meterWater.meterReadingInfo") }}</span>
            <div style="float: right">
              <el-button
                  v-if="conditions.objId"
                  type="primary"
                  size="small"
                  @click="handleOpenAddMeter"
              >
                {{ $t("meterWater.readMeter") }}
              </el-button>
              <!-- 批量删除：有勾选时显示 -->
              <el-button
                  v-if="selectedRows.length > 0"
                  type="danger"
                  size="small"
                  @click="handleBatchDelete"
              >
                批量删除
              </el-button>
              <el-button type="text" size="small" @click="handleOpenMeterType">
                {{ $t("meterWater.meterType") }}
              </el-button>
              <el-button
                  v-if="conditions.objId"
                  type="text"
                  size="small"
                  @click="handleOpenQrCode"
              >
                {{ $t("meterWater.qrCodeMeter") }}
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  style="margin-left: 10px"
                  @click="handleOpenImport1"
              >
                <i class="el-icon-plus"></i>{{ $t("meterWater.import1") }}
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  style="margin-left: 10px"
                  @click="handleOpenImport2"
              >
                <i class="el-icon-plus"></i>{{ $t("meterWater.import2") }}
              </el-button>
            </div>
          </div>
          <el-table
              :data="meterWaters"
              border
              style="width: 100%"
              ref="meterWaterTable"
              @selection-change="handleSelectionChange"
          >
            <!-- 勾选列 -->
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column
                prop="feeStartDate"
                label="费用归属开始日期"
                align="center"
            />
            <el-table-column
                prop="feeEndDate"
                label="费用归属结束日期"
                align="center"
            />
            <el-table-column
                prop="meterTypeName"
                :label="$t('meterWater.meterType')"
                align="center"
            />
            <el-table-column
                prop="objName"
                :label="$t('meterWater.objectName')"
                align="center"
            />
            <el-table-column
                prop="preDegrees"
                :label="$t('meterWater.preDegrees')"
                align="center"
            />
            <el-table-column
                prop="curDegrees"
                :label="$t('meterWater.curDegrees')"
                align="center"
            />
            <el-table-column prop="useDegree" label="用量" align="center" />
            <el-table-column prop="price" label="单价" align="center" />
            <el-table-column prop="totalAmount" label="总金额" align="center" />
            <!-- 统一加【是否】 -->
            <el-table-column label="是否开具发票" align="center" width="130">
              <template slot-scope="scope">
                <el-switch
                    :value="scope.row.invoiceFlag"
                    active-value="1"
                    inactive-value="0"
                    active-text="是"
                    inactive-text="否"
                    @click.native="handleInvoiceClick(scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column label="是否预开发票" align="center" width="130">
              <template slot-scope="scope">
                <el-switch
                    :value="scope.row.preInvoiceFlag"
                    active-value="1"
                    inactive-value="0"
                    active-text="是"
                    inactive-text="否"
                    @click.native="handlePreInvoiceClick(scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column label="是否上缴" align="center" width="110">
              <template slot-scope="scope">
                <el-switch
                    :value="scope.row.payFlag"
                    active-value="1"
                    inactive-value="0"
                    active-text="是"
                    inactive-text="否"
                    @click.native="handlePayFlagClick(scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column
                prop="companyName"
                label="企业名称"
                align="center"
            />
            <el-table-column prop="remarkSign" label="签名" align="center" />

            <el-table-column
                prop="preReadingTime"
                :label="$t('meterWater.preReadingTime')"
                align="center"
            />
            <el-table-column
                prop="curReadingTime"
                :label="$t('meterWater.curReadingTime')"
                align="center"
            />
            <el-table-column
                prop="paymentType"
                :label="$t('meterWater.paymentType')"
                align="center"
            />
            <el-table-column
                prop="paymentStatus"
                :label="$t('meterWater.paymentStatus')"
                align="center"
            />
            <el-table-column
                prop="createTime"
                :label="$t('meterWater.createTime')"
                align="center"
            />
            <el-table-column
                prop="remark"
                :label="$t('meterWater.remark')"
                align="center"
            />
            <el-table-column
                :label="$t('common.operation')"
                align="center"
                width="180"
            >
              <template slot-scope="scope">
                <el-button
                    type="text"
                    size="small"
                    @click="handleEdit(scope.row)"
                >
                  {{ $t("common.edit") }}
                </el-button>
                <el-button
                    type="text"
                    size="small"
                    @click="handleDelete(scope.row)"
                >
                  {{ $t("common.delete") }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
              :current-page="pagination.current"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pagination.size"
              :total="pagination.total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          />
        </el-card>
      </el-col>
    </el-row>

    <!-- 组件 -->
    <add-meter-water ref="addMeterWater" @success="handleSuccess" />
    <edit-meter-water ref="editMeterWater" @success="handleSuccess" />
    <delete-meter-water ref="deleteMeterWater" @success="handleSuccess" />
    <import-meter-water-fee ref="importMeterWaterFee" />
    <import-meter-water-fee2 ref="importMeterWaterFee2" />
    <room-meter-qrcode ref="roomMeterQrcode" />
  </div>
</template>

<script>
import {
  listMeterWaters,
  listMeterTypes,
  updateMeterWater,
  deleteMeterWater,
  exportMeterWaterExcel
} from "@/api/fee/meterWaterManageApi";
import { getCommunityId } from "@/api/community/communityApi";
import RoomTreeDiv from "@/components/room/roomTreeDiv";
import AddMeterWater from "@/components/fee/addMeterWater";
import EditMeterWater from "@/components/fee/editMeterWater";
import DeleteMeterWater from "@/components/fee/deleteMeterWater";
import ImportMeterWaterFee from "@/components/fee/importMeterWaterFee";
import ImportMeterWaterFee2 from "@/components/fee/importMeterWaterFee2";
import RoomMeterQrcode from "@/components/fee/roomMeterQrcode";

export default {
  name: "MeterWaterManageList",
  components: {
    RoomTreeDiv,
    AddMeterWater,
    EditMeterWater,
    DeleteMeterWater,
    ImportMeterWaterFee,
    ImportMeterWaterFee2,
    RoomMeterQrcode,
  },
  data() {
    return {
      exportLoading: false,
      conditions: {
        waterId: "",
        paymentStatus: "",
        paymentType: "",
        meterType: "",
        roomNum: "",
        objId: "",
        floorId: "",
        unitId: "",
        roomId: "",
        page: 1,
        row: 10,
        communityId: "",
        //上期读表时间区间
        preReadingTimeStart: "",
        preReadingTimeEnd: "",
        //本期读表时间区间
        curReadingTimeStart: "",
        curReadingTimeEnd: "",
      },
      preReadingTimeRange: [],
      curReadingTimeRange: [],
      // 勾选中的行
      selectedRows: [],
      meterWaters: [],
      meterTypes: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      roomName: "",
    };
  },
  created() {
    this.conditions.communityId = getCommunityId();
    this.loadData();
    this.loadMeterTypes();
  },
  methods: {
    async loadData() {
      try {
        const { data, total } = await listMeterWaters(this.conditions);
        this.meterWaters = data;
        this.pagination.total = total;
        // 数据刷新后清空勾选
        this.selectedRows = [];
      } catch (error) {
        console.error("Failed to load meter waters:", error);
      }
    },
    async loadMeterTypes() {
      try {
        const { data } = await listMeterTypes({
          communityId: this.conditions.communityId,
          page: 1,
          row: 100,
        });
        this.meterTypes = data;
      } catch (error) {
        console.error("Failed to load meter types:", error);
      }
    },
    //上期读表日期选择回调
    changePreReadingTime(val) {
      if (val && val.length === 2) {
        this.conditions.preReadingTimeStart = val[0];
        this.conditions.preReadingTimeEnd = val[1];
      } else {
        this.conditions.preReadingTimeStart = "";
        this.conditions.preReadingTimeEnd = "";
      }
    },

    async exportExcel() {
      try {
        this.exportLoading = true;
        // 2. 组装导出参数（新增state）
        const params = {
          unitId: this.conditions.unitId,
          floorId: this.conditions.floorId,
          objId: this.conditions.objId,
          roomNum: this.conditions.roomNum,
          meterType: this.conditions.meterType,
          paymentType: this.conditions.paymentType,
          paymentStatus: this.conditions.paymentStatus,
          preReadingTimeStart: this.conditions.preReadingTimeStart,
          preReadingTimeEnd: this.conditions.preReadingTimeEnd,
          curReadingTimeStart: this.conditions.curReadingTimeStart,
          curReadingTimeEnd: this.conditions.curReadingTimeEnd,
          communityId: this.conditions.communityId,
          pagePath: "exportMeterWaterData", // 可选：用于后端标识导出页面
        };

        // 3. 调用导出接口
        const res = await exportMeterWaterExcel(params);

        // 4. 处理导出结果
        if (res && res.code === 0) {
          this.$message.success("水电抄表数据导出成功！");
          // 如果后端返回文件下载链接
          if (res.data && res.data.downloadUrl) {
            window.open(res.data.downloadUrl);
          }
          // 如果是直接返回文件流（另一种常见方式）
          else if (res instanceof Blob) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.download = `水电抄表_${new Date().getTime()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
          // 如果是跳转到下载中心（参考你的示例）
          else {
            window.open("/#/pages/property/downloadTempFile?tab=下载中心");
          }
        } else {
          this.$message.error(res.msg || "水电抄表数据导出失败");
        }
      } catch (error) {
        console.error("导出Excel失败：", error);
        this.$message.error("导出Excel失败，请重试");
      } finally {
        this.exportLoading = false;
      }
    },
    //本期读表日期选择回调
    changeCurReadingTime(val) {
      if (val && val.length === 2) {
        this.conditions.curReadingTimeStart = val[0];
        this.conditions.curReadingTimeEnd = val[1];
      } else {
        this.conditions.curReadingTimeStart = "";
        this.conditions.curReadingTimeEnd = "";
      }
    },
    handleQuery() {
      this.conditions.page = 1;
      this.loadData();
    },
    handleReset() {
      this.conditions.waterId = "";
      this.conditions.paymentStatus = "";
      this.conditions.paymentType = "";
      this.conditions.meterType = "";
      this.conditions.roomNum = "";
      this.conditions.objId = "";
      this.conditions.floorId = "";
      this.conditions.unitId = "";
      this.conditions.roomId = "";
      //清空时间查询条件
      this.conditions.preReadingTimeStart = "";
      this.conditions.preReadingTimeEnd = "";
      this.conditions.curReadingTimeStart = "";
      this.conditions.curReadingTimeEnd = "";
      this.preReadingTimeRange = [];
      this.curReadingTimeRange = [];

      this.roomName = "";
      this.loadData();
    },
    handleSizeChange(val) {
      this.conditions.row = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.conditions.page = val;
      this.loadData();
    },
    // 树节点选中：接收 floorId / unitId / roomId
    handleSelectRoom({ floorId, unitId, roomId, roomName }) {
      this.conditions.floorId = floorId || "";
      this.conditions.unitId = unitId || "";
      this.conditions.roomId = roomId || "";
      this.roomName = roomName;
      this.handleQuery();
    },
    handleOpenAddMeter() {
      this.$refs.addMeterWater.open({
        roomId: this.conditions.roomId,
        roomName: this.roomName,
      });
    },
    handleEdit(row) {
      this.$refs.editMeterWater.open(row);
    },
    handleDelete(row) {
      this.$refs.deleteMeterWater.open(row);
    },
    handleOpenImport1() {
      this.$refs.importMeterWaterFee.open();
    },
    handleOpenImport2() {
      this.$refs.importMeterWaterFee2.open();
    },
    handleOpenQrCode() {
      this.$refs.roomMeterQrcode.open({
        roomId: this.conditions.roomId,
        roomName: this.roomName,
      });
    },
    handleOpenMeterType() {
      this.$router.push("/views/fee/meterTypeManage");
    },
    handleSuccess() {
      this.loadData();
    },

    // ===================== 勾选 + 批量删除 =====================
    // 表格勾选变化
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    // 批量删除（一次确认，串行删除）
    async handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先勾选要删除的记录！");
        return;
      }
      const count = this.selectedRows.length;
      try {
        await this.$confirm(`确定要删除选中的 ${count} 条抄表记录吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        for (const row of this.selectedRows) {
          await deleteMeterWater({ waterId: row.waterId });
        }
        this.$message.success(`${count}条数据删除成功`);
        this.$refs.meterWaterTable.clearSelection();
        this.selectedRows = [];
        this.loadData();
      } catch (e) {
        console.log("删除取消或异常", e);
      }
    },

    // ===================== 开关切换事件 =====================
    // 是否开具发票
    async handleInvoiceClick(row) {
      const oldVal = row.invoiceFlag;
      const newVal = oldVal === "1" ? "0" : "1";

      this.$confirm("是否确认修改【是否开具发票】状态？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            row.invoiceFlag = newVal;
            await updateMeterWater({
              waterId: row.waterId,
              invoiceFlag: row.invoiceFlag,
            });
            this.$message.success("修改成功！");
            this.loadData();
          })
          .catch(() => {});
    },

    // 是否预开发票
    async handlePreInvoiceClick(row) {
      const oldVal = row.preInvoiceFlag;
      const newVal = oldVal === "1" ? "0" : "1";

      this.$confirm("是否确认修改【是否预开发票】状态？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            row.preInvoiceFlag = newVal;
            await updateMeterWater({
              waterId: row.waterId,
              preInvoiceFlag: row.preInvoiceFlag,
            });
            this.$message.success("修改成功！");
            this.loadData();
          })
          .catch(() => {});
    },

    // 是否上缴
    async handlePayFlagClick(row) {
      const oldVal = row.payFlag;
      const newVal = oldVal === "1" ? "0" : "1";

      this.$confirm("是否确认修改【是否上缴】状态？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            row.payFlag = newVal;
            await updateMeterWater({
              waterId: row.waterId,
              payFlag: row.payFlag,
            });
            this.$message.success("修改成功！");
            this.loadData();
          })
          .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.meter-water-manage-container {
  padding: 20px;

  .tree-container {
    min-height: 450px;
    overflow-y: auto;
    background: #fff;
    padding: 10px;
    border-radius: 4px;
  }

  .margin-top {
    margin-top: 20px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }
}
</style>
